import React from 'react';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import { isInvestor } from 'utils';
import { ReactComponent as WarningBlue } from 'assets/icons/warning-blue.svg';
//import { ReactComponent as WarningPurple } from 'assets/icons/warning-purple.svg';
import { outcomes } from 'utils';

const CustomModal = ({
  isVisible,
  title,
  handleConfirm,
  handleCancel,
  children,
  submitDisabled,
  formKey,
  Icon,
  outcome,
  okButtonClassName,
  ...rest
}) => {
  const user = useSelector(state => state.user);
  const investor = isInvestor(user.privileges);
  const renderIcon = () => {
    if (investor) {
      return <WarningBlue />;
    } 
    // else if (isBankFinalReview) {
    //   return <WarningRed />;
    // } else {
    //   return <WarningPurple />;
    // }
  };

  return (
    <Modal
      open={isVisible}
      onOk={handleConfirm}
      onCancel={handleCancel}
      centered
      className={`custom-modal`}
      okButtonProps={{
        disabled: submitDisabled,
        className: okButtonClassName
      }}
      cancelButtonProps={{
        className: 'custom-modal__cancel-button',
      }}
      {...rest}
    >
      <div className="modal-header" style={{display:"flex"}}>{Icon ? <Icon /> : renderIcon()}<span>{title}</span></div>
      <div className="modal-body">{children}</div>
    </Modal>
  );
};

export default CustomModal;
